import styles from './StaticTable.module.scss';

interface StaticTableProps {
  tableData: Array<any>;
}

const StaticTable = (props: StaticTableProps) => {
  const { tableData } = props;

  const [header, ...body] = tableData;

  return tableData.length ? (
    <table className={styles.staticTable}>
      <thead>
        <tr>
          {header.map((name: string) => (
            <td className={styles.staticTable} key={name}>
              <strong>{name}</strong>
            </td>
          ))}
        </tr>
      </thead>
      <tbody>
        {body.map((descriptions: [], i) => (
          <tr key={`descriptions[${i + 10}]`}>
            {descriptions.map((col) => (
              <td key={col}>{col}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  ) : null;
};

export default StaticTable;
